// extracted by mini-css-extract-plugin
module.exports = {"root":"Bouncer_root__1GMRK","loader":"Bouncer_loader__1Vveg","rotate":"Bouncer_rotate__2DZsj","ball1":"Bouncer_ball1__2XqA2","ball2":"Bouncer_ball2__1bGC_"};